import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { DataService } from 'src/app/shared/services/data.service';
@Component({
  selector: 'app-shop',
  templateUrl: './shop.component.html',
  styleUrls: ['./shop.component.scss']
})
export class ShopComponent implements OnInit {
   paths = ['GEN_', 'SLT_', 'machine-prod-items', 'mfg-land'];
  paramValue: any;
  genieName:string;
  @ViewChild('header') header: ElementRef | undefined;
  headerHeight: number = 0;
  showScannerAnimate:boolean=false;
  constructor(private router: Router,
     private activatedRoute: ActivatedRoute,
    private dataService: DataService) {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
         console.log("url",event.url)
        if(this.paths.some(path => event.url.includes(path))){
          this.showScannerAnimate=true;
        }
        else{
          this.showScannerAnimate=false;
        }
        }
  });
  }

  ngOnInit() {
    this.genieName = localStorage.getItem("genieName");
    this.dataService.genieNameEmitter.subscribe((value)=>{
      if(value) this.genieName=value;
    });
    
  }
   calculateHeaderHeight(): void {
    if (this.header) {
      this.headerHeight = this.header.nativeElement.clientHeight;
      console.log("padding-top",this.headerHeight);
    }
  }
 
}
